import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
Vue.use(VueSweetalert2);

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

import VueNativeNotification from "vue-native-notification";

Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true,
});

import Highcharts from 'highcharts';
import VueHighcharts from 'vue-highcharts';

// load these modules as your need
import loadStock from 'highcharts/modules/stock.js';
import loadMap from 'highcharts/modules/map.js';
import loadGantt from 'highcharts/modules/gantt.js';
import loadDrilldown from 'highcharts/modules/drilldown.js';
// some charts like solid gauge require `highcharts-more.js`, you can find it in official document.
import loadHighchartsMore from 'highcharts/highcharts-more.js';
import loadSolidGauge from 'highcharts/modules/solid-gauge.js';

loadStock(Highcharts);
loadMap(Highcharts);
loadGantt(Highcharts);
loadDrilldown(Highcharts);
loadHighchartsMore(Highcharts);
loadSolidGauge(Highcharts);

Vue.use(VueHighcharts, { Highcharts });

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
Vue.use(DatePicker);

Vue.notification.requestPermission().then(console.log);

import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options_toast = {
  // You can set your default options_toast here
  position: "bottom-left",
  timeout: 5000,
  filterBeforeCreate: (toast, toasts) => {
    if (toasts.filter(
      t => t.type === toast.type
    ).length !== 0) {
      // Returning false discards the toast
      return false;
    }
    // You can modify the toast if you want
    return toast;
  }
};

Vue.use(Toast, options_toast);

const ApiUrl =
  process.env.NODE_ENV == "production"
    ? "https://api.mentarimotor.com/v1"
    // : "http://chevy-backend.ae/v1";
    : "http://localhost:8000/v1"

// Settings axios
axios.defaults.baseURL = ApiUrl;
axios.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response) {
      if (error.response.status == 500) {
        console.log("error 500");
      } else if (error.response.status == 401) {
        localStorage.removeItem("token");
        router.push("/");
      }
    } else if (error.request) {
      // console.log(error.request);
      console.log(error.message);
    } else {
      console.log("Error", error.message);
    }
    return Promise.reject(error);
  }
);

Vue.use(VueAxios, axios);

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);

import ReadMore from 'vue-read-more';
Vue.use(ReadMore);

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
Vue.component("Loading", Loading);

// Bootsrtap
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// import 'bootstrap/dist/css/bootstrap.css'
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(require("vue-moment"));

Vue.config.productionTip = false;

import VueCurrencyInput from "vue-currency-input";

Vue.use(VueCurrencyInput, {
  globalOptions: {
    locale: "en",
    valueAsInteger: true,
    currency: {
      prefix: "Rp ",
    },
    precision: 0,
    autoDecimalMode: true,
    valueRange: { min: 0 },
    allowNegative: false,
    distractionFree: false,
  },
});

const backEnd =
  process.env.NODE_ENV == "production"
    ? "https://api.mentarimotor.com/"
    // : "http://chevy-backend.ae/v1";
    : "https://api.mentarimotor.com/";

import XLSX from "xlsx";

import io from "socket.io-client";

var socket = io("https://socket.mentarimotor.com:30443");

import Multiselect from 'vue-multiselect'

import 'vue-multiselect/dist/vue-multiselect.min.css';
// register globally
Vue.component('multiselect', Multiselect)

new Vue({
  router,
  data() {
    return {
      backEnd: backEnd,
      notification_unread: []
    };
  },
  created() {
    var audio = new Audio(
      require("./assets/notif.mp3")
    );

    var audio_emergency = new Audio(
      require("./assets/notif_emergency.ogg")
    );

    socket.disconnect();
    socket.connect();
    socket.on("socket-id", (data) => {
      var socket_id = data.id;

      socket.emit("register-session", {
        isAdmin: true,
        users_id: 1,
        socket_id: socket_id,
      });
    });


    socket.on("payment-notification", (data) => {
      var res = [];

      if (data.srv_t_status == 3) {
        this.getNotificationUnread();
        res.push(data)
        localStorage.setItem('notification', JSON.stringify(res));
        const notification = {
          title: "Order Recieved",
          options: {
            body: "New order is recieved",
            silent: true,
            icon: require("./assets/images/logo-light.png"),
          },
          events: {
            onclick: function () {
              router.push({
                name: "services_transaction_detail",
                params: { uuid: data.srv_t_uuid },
              });
            },
            onshow: function () {
              audio.autoplay = true;
              audio.play();
            },
          },
        };

        this.$notification.show(
          notification.title,
          notification.options,
          notification.events
        );
      }
    });

    socket.on("new-order-received", (data) => {
      var res = [];

      if (data.services_transaction.srv_t_cat == 3) {
        this.getNotificationUnread();
        res.push(data)
        localStorage.setItem('notification', JSON.stringify(res));
        const notification = {
          title: "Emergency Order Recieved",
          options: {
            body: "Emergency order is recieved",
            silent: true,
            icon: require("./assets/images/logo-light.png"),
          },
          events: {
            onclick: function () {
              router.push({
                name: "services_transaction_detail",
                params: { uuid: data.services_transaction.srv_t_uuid },
              });
            },
            onshow: function () {
              audio_emergency.autoplay = true;
              audio_emergency.play();
            },
          },
        };

        this.$notification.show(
          notification.title,
          notification.options,
          notification.events
        );
      }
    });

    socket.on("socket-id", (data) => {
      console.log(data);
    });
  },
  // mounted() {
  //   this.getNotificationUnread();
  // },
  methods: {
    getNotificationUnread() {
      this.axios
        .get("/notification/admin_unread")
        .then((response) => {
          this.notification_unread = response.data.data;
        });
    },
    _export(event) {
      var table_module = event.target.value;
      var module = event.target.id;
      this.$swal
        .fire({
          title: "Export All Data?",
          // text: "You will not be able to recover this imaginary file!",
          icon: "warning",
          showCancelButton: true,
          // confirmButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.value) {
            this.axios
              .post("/" + table_module + "/exportAll")
              .then((response) => {
                if (response.data.status == 200) {
                  var data = [];
                  if (table_module == 'customers') {
                    data = response.data.data.users;
                  }
                  else {
                    data = response.data.data[table_module];
                  }
                  var worksheet = XLSX.utils.aoa_to_sheet(data);
                  var new_workbook = XLSX.utils.book_new();
                  var date = this.$moment().format("DDMMYYYYHHmmss");
                  worksheet["!cols"] = this.fitToColumn(data);
                  XLSX.utils.book_append_sheet(
                    new_workbook,
                    worksheet,
                    "Sheet 1"
                  );

                  XLSX.writeFile(new_workbook, module + "-" + date + ".xlsx");
                }
              });
          }
        });
    },
    fitToColumn(arrayOfArray) {
      // get maximum character of each column
      return arrayOfArray[0].map((a, i) => ({
        wch: Math.max(
          ...arrayOfArray.map((a2) => (a2[i] ? a2[i].toString().length : ""))
        ),
      }));
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    runSocket(value) {
      socket.emit("update-status-transaction", value);
    },
    runSocketHome(value) {
      socket.emit("approve-home-service", value);
    }
  },
  render: (h) => h(App),
}).$mount("#app");
